import boxlogo from '../../assets/logo/logo-mountq-full.svg'
import { Label } from '../../components/ui/label'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'
import { AlertTriangleIcon, ArrowRight, Loader2 } from 'lucide-react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useMutation, useQuery } from '@tanstack/react-query'
import axios from '../../lib/axios'
import { toast } from 'sonner'
import { useEffect, useState } from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select'
import { z } from 'zod'
import { Trans, useLingui } from '@lingui/react/macro'

const RegisterPage = () => {
    const { t } = useLingui()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const regCode = searchParams.get('regcode')
    const email = searchParams.get('email')

    const [firstname, setfirstname] = useState('');
    const [lastname, setlastname] = useState('');
    const [password, setpassword] = useState('');
    const [language, setlanguage] = useState('nl');

    const { isError, isLoading:isValidating } = useQuery({
        queryKey: [`validate-${regCode}`],
        queryFn: async () => {
            const { data } = await axios.get(`user/validate`, {
                params: {
                    code: regCode,
                    email: email
                }
            })
            console.log(data);
            return data
        }
    })

    const { mutate, reset, isPending, isError:isFailed } = useMutation({
        mutationFn: async () => {
            const { data } = await axios.post('user/registration', {
                code: regCode,
                email: email,
                firstname: firstname,
                lastname: lastname,
                password: password,
                language: language
            })
            return data
        },
        onError: (err) => {
            toast.error(t`Er liep iets mis bij het aanmaken van uw account`, { id:'register' })
            reset()
        },
        onSuccess: () => {
            toast.success(t`Account succesvol aangemaakt`, { id:'register' })
            navigate('/')
        }
    })

    const isComplete = () => {
        try {
            z.object({
                code: z.string().min(1),
                email: z.string().email(),
                firstname: z.string().min(1),
                lastname: z.string().min(1),
                password: z.string().min(1),
                language: z.string().min(1)
            }).parse({
                code: regCode,
                email: email,
                firstname: firstname,
                lastname: lastname,
                password: password,
                language: language
            })
            return true
        } catch (e) {
            return false
        }
    }

    if(isValidating){
        return (
            <div className='container py-8 space-y-8'>
                <div className='flex items-center'>
                    <img className='w-auto h-8 sm:h-12' src={boxlogo} alt="MountQ logo"/>
                </div>
                
                <div className='flex flex-col items-center justify-center space-y-4'>
                    <h1 className='text-xl font-bold sm:text-3xl'><Trans>Even geduld...</Trans></h1>
                    <p className='max-w-md text-sm text-center text-neutral-400'><Trans>We zijn uw registratie aan het controleren. Gelieve nog even te wachten.</Trans></p>
                </div>
            </div>
        )
    }

    if(isError){
        return (
        <div className='container py-8 space-y-8'>
            <div className='flex items-center'>
                <img className='w-auto h-8 sm:h-12' src={boxlogo} alt="MountQ logo"/>
            </div>
            
            <div className='flex flex-col items-center justify-center space-y-4'>
                <h1 className='text-xl font-bold sm:text-3xl'><Trans>Oeps!</Trans></h1>
                <p className='max-w-md text-sm text-center text-neutral-400'><Trans>Uw registratielink is niet (meer) geldig. Gelieve contact op te nemen indien dit zich blijft herhalen.</Trans></p>
                <Link to="/login"><Button variant='outline'><Trans>Naar inloggen</Trans><ArrowRight className='w-4 h-4'/></Button></Link>
            </div>
        </div>
        )
    }
    
  return (
    <div className='container py-8 space-y-8'>
        <div className='flex items-center'>
            <img className='w-auto h-8 sm:h-12' src={boxlogo} alt="MountQ logo"/>
        </div>
        
        <div className='space-y-2'>
            <h1 className='text-xl font-bold sm:text-3xl'><Trans>Registreren</Trans></h1>
            <p className='text-sm text-neutral-400'><Trans>Gelieve volgende gegevens te controleren en verder aan te vullen om uw registratie te voltooien.</Trans></p>
        </div>
        <div className='grid gap-4 sm:grid-cols-2'>
            <div className='col-span-full'>
                <Label><Trans>E-mailadres</Trans></Label>
                <Input defaultValue={email || ''} disabled/>
            </div>
            <div>
                <Label><Trans>Voornaam</Trans></Label>
                <Input value={firstname} onChange={(e)=>{setfirstname(e.currentTarget.value)}}/>
            </div>
            <div>
                <Label><Trans>Achternaam</Trans></Label>
                <Input value={lastname} onChange={(e)=>{setlastname(e.currentTarget.value)}}/>
            </div>
            <div>
                <Label><Trans>Taal</Trans></Label>
                <Select value={language} onValueChange={(v)=>setlanguage(v)}>
                    <SelectTrigger>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value='nl'>Nederlands</SelectItem>
                        <SelectItem value='en'>English</SelectItem>
                        <SelectItem value='fr'>Français</SelectItem>
                    </SelectContent>
                </Select>
            </div>
            <div>
                <Label><Trans>Wachtwoord</Trans></Label>
                <Input value={password} onChange={(e)=>{setpassword(e.currentTarget.value)}} type='password'/>
            </div>

            <div className='col-span-full'>
                <Button
                    onClick={()=>{mutate()}}
                    disabled={!isComplete() || isFailed || isPending}
                >
                    {isFailed && <AlertTriangleIcon className='w-4 h-4'/>}
                    {isPending && <Loader2 className='w-4 h-4 animate-spin'/>}
                    <Trans>Registreren</Trans>
                </Button>
            </div>
            
        </div>
    </div>
  )
}

export default RegisterPage